/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RetryWebhookDeliveryRequest
 */
export interface RetryWebhookDeliveryRequest {
    /**
     * 
     * @type {string}
     * @memberof RetryWebhookDeliveryRequest
     */
    deliveryId: string;
}

/**
 * Check if a given object implements the RetryWebhookDeliveryRequest interface.
 */
export function instanceOfRetryWebhookDeliveryRequest(value: object): value is RetryWebhookDeliveryRequest {
    if (!('deliveryId' in value) || value['deliveryId'] === undefined) return false;
    return true;
}

export function RetryWebhookDeliveryRequestFromJSON(json: any): RetryWebhookDeliveryRequest {
    return RetryWebhookDeliveryRequestFromJSONTyped(json, false);
}

export function RetryWebhookDeliveryRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RetryWebhookDeliveryRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'deliveryId': json['deliveryId'],
    };
}

  export function RetryWebhookDeliveryRequestToJSON(json: any): RetryWebhookDeliveryRequest {
      return RetryWebhookDeliveryRequestToJSONTyped(json, false);
  }

  export function RetryWebhookDeliveryRequestToJSONTyped(value?: RetryWebhookDeliveryRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deliveryId': value['deliveryId'],
    };
}

